import { Moment } from "moment-timezone";
import { isNamePartBlank, getNameParts } from "../../helpers";
import AccountModel from "./AccountModel";
import BaseModel from "./BaseModel";
import moment from "moment";
import { Presence, User, UserStatus } from "@chatscope/use-chat";

export type UserPaymentAddress = {
  country?: string;
  city?: string;
  state?: string;
  street?: string;
  zipcode?: string;
  first_name?: string;
  last_name?: string;
};
export default class UserModel extends BaseModel {
  email?: string;
  uid?: string;
  provider?: string;
  allow_password_change?: boolean;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  fullName?: string;
  // TODO we need to remove the full_name attribute
  full_name?: string;
  phoneNumber?: string;
  birth_date?: Moment | string | null;
  gender?: string;
  profile_picture_url?: string;
  account?: AccountModel;
  country?: string | null;
  native_language?: string | null;
  telawah_id?: string | null;
  academic_level?: string | null;
  content_language?: string | null;
  calendarId?: string | null;
  twilioIdentity?: string | null;
  twilioSid?: string;
  paymentCountry?: string;
  paymentCity?: string;
  paymentState?: string;
  paymentStreet?: string;
  paymentZipcode?: string;

  constructor(arg: any) {
    super(arg);
    this.email = arg.email;
    this.uid = arg.uid;
    this.provider = arg.provider;
    this.allow_password_change = arg.allow_password_change;
    this.full_name = arg.full_name;
    this.birth_date = arg.birth_date;
    this.gender = arg.gender;
    this.fullName = arg.full_name;
    this.country = arg.country;
    this.native_language = arg.native_language;
    this.phoneNumber = arg.phone_number;
    this.twilioIdentity = arg?.twilio_identity ?? "";
    this.twilioSid = arg?.twilio_user_sid;
    this.telawah_id = arg?.telawah_id;
    this.academic_level = arg?.academic_level;
    this.content_language = arg?.content_language;
    this.calendarId = arg?.account?.calendar_id;
    this.paymentCountry = arg.country;
    this.paymentCity = arg.city;
    this.paymentState = arg.state;
    this.paymentStreet = arg.street;
    this.paymentZipcode = arg.zip;
    if (!!arg.account) this.account = AccountModel.fromApiResponse(arg.account);

    this.profile_picture_url = !!arg?.profile_picture_url
      ? arg?.profile_picture_url
      : null;

    if (
      !isNamePartBlank(arg.first_name) &&
      !isNamePartBlank(arg.middle_name) &&
      !isNamePartBlank(arg.last_name)
    ) {
      this.firstName = arg.first_name;
      this.middleName = arg.middle_name;
      this.lastName = arg.last_name;
    } else {
      [this.firstName, this.middleName, this.lastName] = getNameParts(
        arg.full_name
      );
    }
  }

  get name() {
    return `${this.firstName} ${this.middleName} ${this.lastName}`.trim();
  }

  get fullNameWithoutMiddle() {
    return `${this.firstName} ${this.lastName}`.trim();
  }

  getAge() {
    const years = moment().diff(this.birth_date, "years");
    return years;
  }

  get chatUser(): User {
    const _user = new User({
      id: this.email!,
      presence: new Presence({
        status: UserStatus.Available,
        description: "",
      }),

      firstName: this.firstName,
      lastName: this.lastName,
      username: this.account?.email,
      email: this.account?.email,
      avatar: this.profile_picture_url,
      bio: "",
    });
    return _user;
  }

  get paymentAddress(): UserPaymentAddress {
    return {
      country: this.paymentCountry,
      city: this.paymentCity,
      state: this.paymentState,
      street: this.paymentStreet,
      zipcode: this.paymentZipcode,
      first_name: this.firstName,
      last_name: this.lastName,
    };
  }
}
